"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7281],{

/***/ 91375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ ReportProduct_ReportProduct; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(34795);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/AlertText/index.js + 2 modules
var AlertText = __webpack_require__(52337);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/RadioGroup/index.js + 2 modules
var RadioGroup = __webpack_require__(65055);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Link/index.js + 2 modules
var Link = __webpack_require__(10200);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../graphql/build/esm/index.js
var esm = __webpack_require__(76613);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var build_esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Heading/index.js + 1 modules
var Heading = __webpack_require__(25610);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js + 2 modules
var Button = __webpack_require__(60861);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ReviewInput/index.js + 1 modules
var ReviewInput = __webpack_require__(27408);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReportProduct/ReportProduct.style.js


var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;






var ButtonSubmit = (0,styled_components_browser_esm["default"])(Button/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    color: 'secondary',
    size: 'small'
  }, props);
})(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)([""])));
var Content = (0,styled_components_browser_esm["default"])(Box/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    px: 1,
    py: 4
  }, props);
})(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var Description = (0,styled_components_browser_esm["default"])(Box/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    color: 'text.scratched',
    fontSize: [2, 2, 2, 2],
    fontWeight: 'regular',
    lineHeight: 'big',
    textAlign: 'justify'
  }, props);
})(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var HeadingLabel = (0,styled_components_browser_esm["default"])(Heading/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    color: 'base',
    fontSize: 2,
    fontWeight: 'bold',
    lineHeight: 'display',
    my: [2, 2, 3, 3]
  }, props);
})(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var OptionsLabel = (0,styled_components_browser_esm["default"])(Text/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    color: 'base',
    fontSize: [1, 1, 2, 2],
    fontWeight: 'bold',
    paddingY: '20px'
  }, props);
})(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var ReviewArea = (0,styled_components_browser_esm["default"])(ReviewInput/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    flexDirection: ['column'],
    gap: '30px',
    p: '20px',
    textAlign: ['left']
  }, props);
})(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)([""])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReportProduct/ReportProduct.js




var _excluded = ["label", "description", "labelAs", "buttonLabel", "linkLabel", "reviewLabel", "optionsLabel", "myOrdered", "myOrderedLink", "redirectToPath", "reviewPlaceholder", "reviewOptions", "errorEmptyMessage", "somethingWrong"];
function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }










var ReportProduct = function ReportProduct(_ref) {
  var _ref$structure = _ref.structure,
    structure = _ref$structure === void 0 ? {} : _ref$structure,
    staticProps = _ref["static"];
  var label = staticProps.label,
    description = staticProps.description,
    _staticProps$labelAs = staticProps.labelAs,
    labelAs = _staticProps$labelAs === void 0 ? 'h2' : _staticProps$labelAs,
    buttonLabel = staticProps.buttonLabel,
    linkLabel = staticProps.linkLabel,
    reviewLabel = staticProps.reviewLabel,
    optionsLabel = staticProps.optionsLabel,
    myOrdered = staticProps.myOrdered,
    myOrderedLink = staticProps.myOrderedLink,
    redirectToPath = staticProps.redirectToPath,
    reviewPlaceholder = staticProps.reviewPlaceholder,
    reviewOptions = staticProps.reviewOptions,
    errorEmptyMessage = staticProps.errorEmptyMessage,
    _staticProps$somethin = staticProps.somethingWrong,
    somethingWrong = _staticProps$somethin === void 0 ? '' : _staticProps$somethin,
    props = (0,objectWithoutProperties/* default */.Z)(staticProps, _excluded);
  var _useState = (0,react.useState)(null),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    selected = _useState2[0],
    setSelected = _useState2[1];
  var _useState3 = (0,react.useState)(''),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    message = _useState4[0],
    setMessage = _useState4[1];
  var _useState5 = (0,react.useState)(''),
    _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
    errorsValidation = _useState6[0],
    setErrorsValidation = _useState6[1];
  var _ref2 = structure || {},
    _ref2$route = _ref2.route,
    _ref2$route2 = _ref2$route === void 0 ? {} : _ref2$route,
    from = _ref2$route2.from,
    productId = _ref2$route2.productId;
  (0,react.useEffect)(function () {
    setSelected(reviewOptions[0].value);
  }, []);
  var onClickBackProduct = function onClickBackProduct(e) {
    e.preventDefault();
    (0,build_esm/* routePush */.dY)({
      path: from,
      spa: true
    });
  };
  var onClickMyOrdered = function onClickMyOrdered(e) {
    e.preventDefault();
    (0,build_esm/* routePush */.dY)({
      path: myOrderedLink,
      spa: true
    });
  };
  var handleMessage = function handleMessage(e) {
    setMessage(e.target.value);
    if (message !== '') setErrorsValidation('');
  };
  var _useReportProduct = (0,esm.useReportProduct)(),
    data = _useReportProduct.data,
    postData = _useReportProduct.postData,
    error = _useReportProduct.error;
  (0,react.useEffect)(function () {
    if ((data == null ? void 0 : data.message) === 'success') (0,build_esm/* routePush */.dY)({
      path: redirectToPath,
      spa: true
    });
  }, [data]);
  var handleReport = function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (message) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", setErrorsValidation(errorEmptyMessage));
          case 2:
            _context.next = 4;
            return postData({
              message: message,
              option: selected,
              sku: productId
            });
          case 4:
            return _context.abrupt("return", undefined);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleReport() {
      return _ref3.apply(this, arguments);
    };
  }();
  return react.createElement(Content, props, label && react.createElement(HeadingLabel, {
    forwardedAs: labelAs
  }, label), react.createElement(Description, null, description, react.createElement(Link/* default */.Z, {
    underline: true,
    "data-testid": "my-ordered",
    onClick: function onClick(e) {
      return onClickMyOrdered(e);
    },
    href: myOrderedLink,
    fontSize: [2, 2, 2, 2],
    color: "text.scratched"
  }, myOrdered)), react.createElement(OptionsLabel, null, optionsLabel), react.createElement(Box/* default */.Z, {
    "data-testid": "radio-report",
    p: "0 0 25px 0"
  }, react.createElement(RadioGroup/* default */.Z, {
    options: reviewOptions,
    selectedOption: selected,
    p: 1,
    onChange: function onChange(_, option) {
      return setSelected(option.value);
    }
  })), react.createElement(ReviewArea, {
    "data-testid": "message-text",
    label: reviewLabel,
    onChange: function onChange(e) {
      return handleMessage(e);
    },
    type: "textarea",
    error: errorsValidation,
    placeholder: reviewPlaceholder
  }), react.createElement(Box/* default */.Z, {
    p: "20px 0 20px 0"
  }, react.createElement(ButtonSubmit, {
    "data-testid": "submit-button",
    onClick: function onClick() {
      return handleReport();
    }
  }, buttonLabel)), react.createElement(Link/* default */.Z, {
    "data-testid": "back-to-product",
    onClick: function onClick(e) {
      onClickBackProduct(e);
    },
    href: from,
    color: "text.primary"
  }, linkLabel), react.createElement(Box/* default */.Z, {
    p: "20px 0 20px 0"
  }, Boolean(error) && react.createElement(AlertText/* default */.Z, {
    message: somethingWrong,
    intent: "danger"
  })));
};
ReportProduct.defaultProps = {
  "static": {
    buttonLabel: 'Denunciar',
    label: 'Olá. Sobre o que se trata a sua denúncia?',
    labelAs: 'h2',
    linkLabel: 'Voltar ao produto',
    myOrdered: 'Meus Pedidos.',
    optionsLabel: 'Você acredita que o anúncio seja:',
    redirectToPath: '/denuncie/confirmacao',
    reviewLabel: 'Conte mais detalhes sobre a denúncia',
    reviewOptions: [],
    reviewPlaceholder: 'detalhes...'
  },
  structure: {}
};
 false ? 0 : void 0;
ReportProduct.ssr = false;
/* harmony default export */ var ReportProduct_ReportProduct = ((0,withLayoutProps/* default */.Z)(ReportProduct));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReportProduct/index.js


/***/ }),

/***/ 95592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ReviewDimensions_ReviewDimensions; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Review/index.js + 2 modules
var Review = __webpack_require__(73172);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/List/index.js + 10 modules
var List = __webpack_require__(78012);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewDimensions/ReviewDimensions.js








var ReviewDimensions = function ReviewDimensions(_ref) {
  var _data$productRating;
  var staticProps = _ref["static"],
    data = _ref.data;
  var title = staticProps.title;
  var dimensions = (data == null ? void 0 : (_data$productRating = data.productRating) == null ? void 0 : _data$productRating.dimensions) || [];
  return !!(dimensions == null ? void 0 : dimensions.length) && react.createElement(Box/* default */.Z, {
    "data-testid": "review-by-dimension",
    mt: [0, 4],
    mb: [0, 4]
  }, title && react.createElement(Text/* default */.Z, {
    fontWeight: "medium"
  }, title), react.createElement(List/* default */.Z, {
    disableGutters: true,
    scale: "small",
    dataSource: dimensions,
    renderItem: function renderItem(dimension) {
      var label = dimension.label,
        rating = dimension.rating;
      return react.createElement(Flex/* default */.Z, {
        "data-testid": "dimension-rating",
        mt: 3,
        justifyContent: "space-between"
      }, react.createElement(Text/* default */.Z, {
        lineHeight: 1.2,
        fontSize: 2
      }, label), react.createElement(Flex/* default */.Z, {
        gap: 2
      }, react.createElement(Review/* default */.Z, {
        score: rating,
        width: [15, 20],
        height: [15, 20],
        mr: 1
      }), react.createElement(Text/* default */.Z, {
        fontSize: 2
      }, rating.toFixed(1))));
    }
  }));
};
ReviewDimensions.ssr = true;
 false ? 0 : void 0;
ReviewDimensions.defaultProps = {
  data: {},
  "static": {
    title: ''
  }
};
/* harmony default export */ var ReviewDimensions_ReviewDimensions = ((0,withLayoutProps/* default */.Z)(ReviewDimensions));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewDimensions/index.js


/***/ }),

/***/ 89591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ReviewForm_ReviewForm; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(34795);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/AlertText/index.js + 2 modules
var AlertText = __webpack_require__(52337);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ReviewForm/index.js + 2 modules
var organisms_ReviewForm = __webpack_require__(79534);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../graphql/build/esm/index.js
var graphql_build_esm = __webpack_require__(76613);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewForm/AgreedLabel.js

var _templateObject;




var TextAnchor = (0,styled_components_browser_esm["default"])(Text/* default */.Z).attrs({
  role: 'contentinfo'
})(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  cursor: pointer;\n  text-decoration: underline;\n"])));
var AgreedLabel = function AgreedLabel(_ref) {
  var onClick = _ref.onClick;
  return react.createElement(Text/* default */.Z, {
    as: "span",
    display: "flex",
    width: 1,
    gap: [0, 1],
    flexDirection: ['column', 'row'],
    fontSize: [1, 2]
  }, "Concordo com os", react.createElement(TextAnchor, {
    "data-testid": "review-terms",
    onClick: onClick
  }, "termos e condi\xE7\xF5es"));
};
 false ? 0 : void 0;
/* harmony default export */ var ReviewForm_AgreedLabel = (AgreedLabel);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewForm/ReviewForm.js



function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }










var buildUserLocation = function buildUserLocation(location) {
  try {
    return "".concat(location.zipCodeCity, " - ").concat(location.zipCodeState.toUpperCase());
  } catch (e) {
    return '';
  }
};
var ReviewForm = function ReviewForm(_ref) {
  var _config$publicRuntime, _config$publicRuntime2, _review$addProductRev;
  var staticProps = _ref["static"],
    data = _ref.data,
    structure = _ref.structure,
    config = _ref.config;
  var reviewCharacteristics = data.reviewCharacteristics;
  var _structure$route = structure == null ? void 0 : structure.route,
    productId = _structure$route.productId,
    campaignId = _structure$route.campaignId,
    rd = _structure$route.rd;
  var _ref2 = (structure == null ? void 0 : structure.cookies) || {},
    partnerId = _ref2.partnerId,
    userId = _ref2.customerId,
    accountData = _ref2.accountData,
    location = _ref2.location;
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var _useReview = (0,graphql_build_esm.useReview)({
      context: {
        timeout: config == null ? void 0 : (_config$publicRuntime = config.publicRuntimeConfig) == null ? void 0 : (_config$publicRuntime2 = _config$publicRuntime.review) == null ? void 0 : _config$publicRuntime2.timeout
      }
    }),
    mutateData = _useReview.mutateData,
    error = _useReview.error,
    review = _useReview.review;
  var addProductReview = (0,react.useCallback)(function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee(form, clearForm) {
      var _result$addProductRev, _result$addProductRev2, _result$addProductRev3, _result$addProductRev4;
      var recommended, characteristics, variables, _yield$mutateData, result, err;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            recommended = form.recommended === 'like';
            characteristics = form.characteristics.map(function (_ref4) {
              var id = _ref4.id,
                value = _ref4.value;
              return {
                name: id,
                value: value
              };
            });
            variables = (0,esm_extends/* default */.Z)({}, form, {
              campaignId: campaignId,
              characteristics: characteristics,
              partnerId: partnerId,
              productId: productId,
              recommended: recommended,
              reviewDataJWT: rd,
              userId: userId,
              userLocation: buildUserLocation(location),
              userName: (0,esm/* textEllipsis */.vS)(accountData == null ? void 0 : accountData.name, 24)
            });
            _context.next = 5;
            return mutateData(variables);
          case 5:
            _yield$mutateData = _context.sent;
            result = _yield$mutateData.data;
            err = _yield$mutateData.error;
            publish('product:review:submit', {
              errorMessage: (result == null ? void 0 : (_result$addProductRev = result.addProductReview) == null ? void 0 : (_result$addProductRev2 = _result$addProductRev.payloadErrors) == null ? void 0 : _result$addProductRev2.map(function (_ref5) {
                var message = _ref5.message;
                return message;
              }).join(' | ')) || err,
              status: result == null ? void 0 : (_result$addProductRev3 = result.addProductReview) == null ? void 0 : _result$addProductRev3.status
            });
            if ((result == null ? void 0 : (_result$addProductRev4 = result.addProductReview) == null ? void 0 : _result$addProductRev4.status) === 'OK') {
              clearForm();
            }
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }(), [partnerId, productId, userId, location, accountData == null ? void 0 : accountData.name]);
  return react.createElement(react.Fragment, null, react.createElement(organisms_ReviewForm/* default */.Z, {
    onSubmit: addProductReview,
    agreedLabel: react.createElement(ReviewForm_AgreedLabel, {
      onClick: function onClick(e) {
        e.preventDefault();
        publish('review:terms:open');
      }
    }),
    reviewCharacteristics: reviewCharacteristics,
    focus: staticProps.inputFocus
  }), (error || review) && react.createElement(Flex/* default */.Z, {
    pt: 3,
    flexDirection: ['column', 'row'],
    gap: [0, 30]
  }, react.createElement(Flex/* default */.Z, {
    flex: "0.75"
  }), react.createElement(Flex/* default */.Z, {
    flex: "1",
    gap: "2",
    alignItems: ['center', 'start'],
    justifyContent: "space-evenly",
    flexDirection: "column"
  }, error && react.createElement(AlertText/* default */.Z, {
    message: error,
    intent: "danger"
  }), (review == null ? void 0 : (_review$addProductRev = review.addProductReview) == null ? void 0 : _review$addProductRev.status) === 'OK' && react.createElement(react.Fragment, null, react.createElement(AlertText/* default */.Z, {
    message: "Avalia\xE7\xE3o foi enviada com sucesso.",
    intent: "success"
  }), react.createElement(AlertText/* default */.Z, {
    message: "Iremos analisar a sua avalia\xE7\xE3o e poder\xE1 demorar alguns dias at\xE9 que ela apare\xE7a. Obrigado.",
    intent: "info"
  })))));
};
ReviewForm.defaultProps = {
  config: {},
  "static": {
    inputFocus: true
  }
};
 false ? 0 : void 0;
ReviewForm.dataSource = {
  reviewCharacteristics: {
    query: 'ReviewCharacteristicsQuery'
  }
};
ReviewForm.ssr = true;
/* harmony default export */ var ReviewForm_ReviewForm = ((0,withLayoutProps/* default */.Z)(ReviewForm));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewForm/index.js


/***/ }),

/***/ 15860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ReviewHeaderMobile_ReviewHeaderMobile; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var build_esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var stereo_ui_styles_build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewHeaderMobile/ButtonAction/ButtonAction.styles.js

var _templateObject;



var Button = (0,styled_components_browser_esm["default"])(atoms/* Button */.zx)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  height: 32px;\n  padding: 6px 8px 6px 8px;\n  justify-content: center;\n  align-items: center;\n  gap: ", "px;\n  background-color: transparent;\n  box-shadow: none;\n  border-radius: 32px;\n  min-width: 100px !important;\n  border: 1px solid ", ";\n\n  &:hover {\n    box-shadow: none;\n  }\n\n  label {\n    font-size: ", "px;\n    font-weight: ", ";\n    line-height: ", ";\n    line-height: 16px;\n    color: #343b3f;\n    &:hover {\n      color: #343b3f;\n    }\n  }\n  svg {\n    fill: ", ";\n    line-height: ", ";\n    &:hover {\n      fill: ", ";\n    }\n  }\n"])), (0,stereo_ui_styles_build_esm.themeGet)('space.1'), (0,stereo_ui_styles_build_esm.themeGet)('baseColors.gray.light'), (0,stereo_ui_styles_build_esm.themeGet)('fontSizes.1'), (0,stereo_ui_styles_build_esm.themeGet)('fontWeights.medium'), (0,stereo_ui_styles_build_esm.themeGet)('lineHeights.plus'), (0,stereo_ui_styles_build_esm.themeGet)('baseColors.gray.dark'), (0,stereo_ui_styles_build_esm.themeGet)('lineHeights.plus'), (0,stereo_ui_styles_build_esm.themeGet)('baseColors.gray.dark'));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewHeaderMobile/ButtonAction/ButtonAction.js


var _excluded = ["label", "endIcon", "startIcon", "variation"];



var ButtonAction = function ButtonAction(_ref) {
  var label = _ref.label,
    endIcon = _ref.endIcon,
    startIcon = _ref.startIcon,
    variation = _ref.variation,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);
  return react.createElement(Button, (0,esm_extends/* default */.Z)({
    endIcon: endIcon,
    startIcon: startIcon,
    uppercase: false,
    variation: variation,
    centered: true,
    "data-testid": "button-action"
  }, props), label);
};
 false ? 0 : void 0;
ButtonAction.defaultProps = {
  endIcon: '',
  label: '',
  startIcon: '',
  variation: ''
};
/* harmony default export */ var ButtonAction_ButtonAction = (ButtonAction);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewHeaderMobile/ButtonAction/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewHeaderMobile/DialogReview/DialogReview.styles.js

var DialogReview_styles_templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;



var BoxContainer = (0,styled_components_browser_esm["default"])(atoms/* Box */.xu)(DialogReview_styles_templateObject || (DialogReview_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n  padding: ", "px;\n"])), (0,stereo_ui_styles_build_esm.themeGet)('space.3'));
var ButtonClear = (0,styled_components_browser_esm["default"])(atoms/* Button */.zx)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  label {\n    color: ", ";\n  }\n"])), function (props) {
  return props.disabled ? '' : (0,stereo_ui_styles_build_esm.getTextColor)('dark');
});
var ButtonContainer = (0,styled_components_browser_esm["default"])(atoms/* Box */.xu)(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  height: 48px;\n  align-items: center;\n  justify-content: space-around;\n  display: flex;\n  flex-direction: row;\n"])));
var Container = (0,styled_components_browser_esm["default"])(atoms/* Box */.xu)(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: row;\n  background-color: ", ";\n  width: 100%;\n  height: 80px;\n  padding: 16px 20px 16px 20px;\n  justify-content: center;\n  align-items: center;\n"])), (0,stereo_ui_styles_build_esm.getBackgroundColor)('white'));
var DialogContainer = (0,styled_components_browser_esm["default"])(atoms/* Dialog */.Vq)(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100% !important;\n  margin: 0px;\n  padding: 0px;\n  height: 360px;\n  justify-content: space-between;\n  display: flex;\n  flex-direction: column;\n  overflow-x: hidden !important;\n  border-top-right-radius: 0px !important;\n  border-top-left-radius: 0px !important;\n  > div:first-child {\n    padding: 12px 8px 12px 16px;\n  }\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewHeaderMobile/DialogReview/DialogReview.js




var DialogReview = function DialogReview(_ref) {
  var open = _ref.open,
    children = _ref.children,
    title = _ref.title,
    contentText = _ref.contentText,
    handleCloseModal = _ref.handleCloseModal,
    handleSubmit = _ref.handleSubmit,
    handleClear = _ref.handleClear,
    disabledButton = _ref.disabledButton;
  return react.createElement(react.Fragment, null, open && react.createElement(DialogContainer, {
    title: ('title', title),
    titleStyle: {
      color: 'base',
      fontSize: '20px',
      lineHeight: '25px'
    },
    showClose: true,
    showHorizontalRule: true,
    bgRule: "border.base",
    onClickOutside: handleCloseModal
  }, react.createElement(atoms/* Flex */.kC, {
    flexDirection: "column",
    p: 2
  }, react.createElement(atoms/* Text */.xv, {
    pl: "24px",
    fontSize: 2,
    lineHeight: "24px",
    fontWeight: "600",
    fontFamily: "roboto",
    "data-testid": "title-filter"
  }, contentText), react.createElement(BoxContainer, null, children)), react.createElement(Container, null, react.createElement(ButtonContainer, null, react.createElement(ButtonClear, {
    disabled: disabledButton,
    onClick: handleClear,
    "data-testid": "sort-clear",
    color: "dark"
  }, "Limpar"), react.createElement(atoms/* Button */.zx, {
    onClick: handleSubmit,
    "data-testid": "sort-submit"
  }, "Aplicar")))));
};
 false ? 0 : void 0;
DialogReview.defaultProps = {
  children: null,
  contentText: '',
  disabledButton: true,
  handleClear: function handleClear() {},
  handleCloseModal: function handleCloseModal() {},
  handleSubmit: function handleSubmit() {},
  open: false,
  title: ''
};
/* harmony default export */ var DialogReview_DialogReview = (DialogReview);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewHeaderMobile/DialogReview/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewHeaderMobile/SortSelect/SortSelect.js








var SortSelect = function SortSelect(_ref) {
  var _structure$route;
  var structure = _ref.structure;
  var query = structure.query,
    config = structure.config;
  var _ref2 = config || {},
    isMiniApp = _ref2.isMiniApp;
  var _React$useState = react.useState(false),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    showFloatModal = _React$useState2[0],
    setShowFloatModal = _React$useState2[1];
  var selectedOption = (_structure$route = structure.route) == null ? void 0 : _structure$route.sortType;
  var _React$useState3 = react.useState(selectedOption),
    _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
    selectedSort = _React$useState4[0],
    setSelectedSort = _React$useState4[1];
  var sortTypes = [{
    type: 'Mais recentes',
    value: 'MOST_RECENT'
  }, {
    type: 'Mais relevantes',
    value: 'MORE_RELEVANT'
  }, {
    type: 'Avaliações positivas',
    value: 'MORE_POSITIVE'
  }, {
    type: 'Avaliações negativas',
    value: 'MORE_NEGATIVE'
  }];
  var handleRouteChange = function handleRouteChange(path) {
    return isMiniApp ? (0,build_esm/* routeReplace */.fV)({
      path: path
    }) : (0,build_esm/* routePush */.dY)({
      path: path,
      spa: true
    });
  };
  var onSubmitSort = function onSubmitSort(e) {
    e.preventDefault();
    var sort = sortTypes.some(function (sortType) {
      return sortType.value === selectedSort;
    });
    if (sort) {
      var path = (0,build_esm/* getCurrentPath */.Jz)({
        page: 1,
        sortType: selectedSort
      });
      handleRouteChange(path);
    }
    setShowFloatModal(false);
  };
  var handleClearSort = function handleClearSort(e) {
    e.preventDefault();
    setSelectedSort('');
    if (query == null ? void 0 : query.sortType) {
      delete query.sortType;
      var path = (0,build_esm/* urlCleanSelectedFilters */.Ld)([], query, structure);
      handleRouteChange(path);
    }
    setShowFloatModal(false);
  };
  return react.createElement(atoms/* Flex */.kC, null, react.createElement(ButtonAction_ButtonAction, {
    variation: "outline",
    label: "Ordenar",
    endIcon: react.createElement(esm/* Icon */.JO$, {
      name: "ChevronDown"
    }),
    onClick: function onClick() {
      return setShowFloatModal(true);
    }
  }), react.createElement(DialogReview_DialogReview, {
    open: showFloatModal,
    title: "Coment\xE1rios dos clientes",
    contentText: "Ordenar:",
    handleSubmit: onSubmitSort,
    handleClear: handleClearSort,
    disabledButton: !selectedSort,
    handleCloseModal: function handleCloseModal() {
      return setShowFloatModal(false);
    }
  }, sortTypes.map(function (item) {
    return react.createElement(atoms/* Chip */.Af, {
      as: "a",
      type: "radio",
      onClick: function onClick() {
        return setSelectedSort(item.value);
      },
      checked: selectedSort === item.value,
      value: item.value,
      key: item.value,
      id: item.value,
      autoSize: true,
      m: 2,
      fontSize: "14px",
      lineHeight: "16px",
      bg: "whisper",
      scales: {
        dark: "#343B3F",
        light: "#fff"
      }
    }, item.type);
  })));
};
 false ? 0 : void 0;
SortSelect.defaultProps = {
  structure: {
    route: {}
  }
};
SortSelect.ssr = true;
/* harmony default export */ var SortSelect_SortSelect = (SortSelect);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewHeaderMobile/SortSelect/index.js

// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var publisher_build_esm = __webpack_require__(87333);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewHeaderMobile/SelectByRating/SelectRating.styles.js

var SelectRating_styles_templateObject, SelectRating_styles_templateObject2;



var FilterCount = (0,styled_components_browser_esm["default"])(atoms/* Text */.xv).attrs({
  bg: 'background.primary',
  borderRadius: 'circle',
  color: 'text.lightest',
  fontSize: 0
})(SelectRating_styles_templateObject || (SelectRating_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  border-radius: ", ";\n  line-height: ", "px;\n  display: block;\n  height: 18px;\n  width: 18px;\n"])), (0,stereo_ui_styles_build_esm.themeGet)('radii.circle'), (0,stereo_ui_styles_build_esm.themeGet)('lineHeights.tall'));
var TextChip = (0,styled_components_browser_esm["default"])(atoms/* Text */.xv)(SelectRating_styles_templateObject2 || (SelectRating_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  gap: 4px;\n  font-weight: 400;\n  color: #000;\n  font-size: ", "px;\n  line-height: 18px;\n\n  &::first-letter {\n    font-weight: 500 !important;\n    color: #000;\n  }\n"])), (0,stereo_ui_styles_build_esm.themeGet)('fontSizes.2'));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewHeaderMobile/SelectByRating/SelectByRating.js











var SelectByRating = function SelectByRating(_ref) {
  var structure = _ref.structure,
    data = _ref.data;
  var _React$useState = react.useState(false),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    showFloatModal = _React$useState2[0],
    setShowFloatModal = _React$useState2[1];
  var _ref2 = data.productRating || {},
    _ref2$reviewsByRating = _ref2.reviewsByRating,
    reviewsByRating = _ref2$reviewsByRating === void 0 ? [] : _ref2$reviewsByRating;
  var _ref3 = (structure == null ? void 0 : structure.route) || {},
    _ref3$filters = _ref3.filters,
    filters = _ref3$filters === void 0 ? [] : _ref3$filters;
  var query = structure.query,
    config = structure.config;
  var _ref4 = config || {},
    isMiniApp = _ref4.isMiniApp;
  var _usePublisher = (0,publisher_build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var reviewsByRatingData = reviewsByRating.map(function (ratingReview) {
    var rating = ratingReview.rating,
      total = ratingReview.total;
    var rate = new Map([[1, 'ONE_STAR'], [2, 'TWO_STARS'], [3, 'THREE_STARS'], [4, 'FOUR_STARS'], [5, 'FIVE_STARS']]);
    return {
      href: "rating---".concat(rate.get(rating)),
      key: rating,
      selected: false,
      total: total,
      type: rate.get(rating),
      value: rating
    };
  });
  var handleRouteChange = function handleRouteChange(path) {
    return isMiniApp ? (0,build_esm/* routeReplace */.fV)({
      path: path
    }) : (0,build_esm/* routePush */.dY)({
      path: path,
      spa: true
    });
  };
  var selectedFilter = filters.filter(function (filter) {
    return filter.type === 'rating';
  });
  var updatedReviewsByRatingData = reviewsByRatingData.map(function (item) {
    var _rating$;
    var rating = filters.filter(function (filter) {
      return filter.type === 'rating';
    }).map(function (filter) {
      return {
        type: filter.type,
        value: filter.value
      };
    });
    if (item.type === ((_rating$ = rating[0]) == null ? void 0 : _rating$.value)) {
      return (0,esm_extends/* default */.Z)({}, item, {
        selected: true
      });
    }
    return item;
  });
  var _React$useState3 = react.useState(updatedReviewsByRatingData),
    _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
    options = _React$useState4[0],
    setOptions = _React$useState4[1];
  var onChange = function onChange(filter) {
    if (filter.total === 0) return;
    var newValue = options.map(function (item) {
      var same = item.value === filter.value;
      return (0,esm_extends/* default */.Z)({}, item, {
        selected: !!same
      });
    });
    setOptions(newValue);
  };
  var onSubmitFilterRating = function onSubmitFilterRating(e) {
    e.preventDefault();
    var filterRating = options.find(function (item) {
      return item.selected;
    });
    if (!filterRating) {
      setShowFloatModal(false);
      return;
    }
    var rating = filters.filter(function (item) {
      return (item == null ? void 0 : item.type) === filterRating.type;
    });
    if (rating) {
      var path = (0,build_esm/* getCurrentPath */.Jz)({
        filters: filterRating == null ? void 0 : filterRating.href,
        page: 1
      });
      handleRouteChange(path);
      publish('review:filter:click', filterRating.type, {
        data: data,
        structure: structure
      });
    }
    setShowFloatModal(false);
  };
  var handleClearFilterRating = function handleClearFilterRating(e) {
    e.preventDefault();
    var clearSelect = options.map(function (item) {
      return (0,esm_extends/* default */.Z)({}, item, {
        selected: false
      });
    });
    setOptions(clearSelect);
    var rating = filters.filter(function (item) {
      return item.type === 'rating';
    }).map(function (item) {
      return {
        type: item.type,
        value: item.value
      };
    });
    if (query == null ? void 0 : query.filters) {
      var path = (0,build_esm/* urlCleanSelectedFilters */.Ld)(rating, query, structure);
      handleRouteChange(path);
    }
    setShowFloatModal(false);
  };
  var renderTextChip = function renderTextChip(_ref5) {
    var label = _ref5.label,
      total = _ref5.total;
    return react.createElement(TextChip, {
      as: "span"
    }, label, react.createElement(esm/* Star */.Uxw, {
      color: "text.scratched",
      height: 16,
      width: 16
    }), "(".concat(total, ")"));
  };
  return react.createElement(atoms/* Flex */.kC, null, react.createElement(ButtonAction_ButtonAction, {
    variation: "outline",
    label: "Filtrar",
    startIcon: Boolean(selectedFilter == null ? void 0 : selectedFilter.length) && react.createElement(FilterCount, {
      "data-testid": "filter-count",
      forwardedAs: "span"
    }, selectedFilter == null ? void 0 : selectedFilter.length),
    endIcon: react.createElement(esm/* Icon */.JO$, {
      name: "ChevronDown"
    }),
    onClick: function onClick() {
      return setShowFloatModal(true);
    },
    width: "90px"
  }), react.createElement(DialogReview_DialogReview, {
    open: showFloatModal,
    title: "Coment\xE1rios dos clientes",
    contentText: "Filtrar:",
    handleSubmit: onSubmitFilterRating,
    handleClear: handleClearFilterRating,
    disabledButton: !options.some(function (option) {
      return option.selected;
    }),
    handleCloseModal: function handleCloseModal() {
      return setShowFloatModal(false);
    }
  }, options == null ? void 0 : options.map(function (item) {
    return react.createElement(atoms/* Chip */.Af, {
      as: "a",
      onClick: function onClick() {
        return onChange(item);
      },
      checked: item == null ? void 0 : item.selected,
      value: String(item == null ? void 0 : item.value),
      key: String(item == null ? void 0 : item.key),
      id: String(item == null ? void 0 : item.value),
      type: "radio",
      autoSize: true,
      padding: "8px",
      bg: "whisper",
      fontSize: "14px",
      lineHeight: "16px",
      m: 3,
      scales: {
        dark: "#343B3F",
        light: "#fff"
      }
    }, renderTextChip({
      label: item == null ? void 0 : item.value,
      total: item == null ? void 0 : item.total
    }));
  })));
};
 false ? 0 : void 0;
SelectByRating.defaultProps = {
  data: {},
  structure: {}
};
SelectByRating.ssr = true;
/* harmony default export */ var SelectByRating_SelectByRating = (SelectByRating);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewHeaderMobile/SelectByRating/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewHeaderMobile/ReviewHeaderMobile.js






var ReviewHeaderMobile = function ReviewHeaderMobile(_ref) {
  var data = _ref.data,
    structure = _ref.structure;
  return react.createElement(atoms/* Flex */.kC, {
    padding: "8px 16px",
    gap: 50,
    "data-testid": "review-list-header-mobile"
  }, react.createElement(SortSelect_SortSelect, {
    structure: structure
  }), react.createElement(SelectByRating_SelectByRating, {
    data: data,
    structure: structure
  }));
};
 false ? 0 : void 0;
ReviewHeaderMobile.defaultProps = {
  data: {},
  structure: {}
};
ReviewHeaderMobile.ssr = true;
/* harmony default export */ var ReviewHeaderMobile_ReviewHeaderMobile = ((0,withLayoutProps/* default */.Z)(ReviewHeaderMobile));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewHeaderMobile/index.js


/***/ }),

/***/ 95107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ReviewListHeader_ReviewListHeader; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Select/index.js + 2 modules
var Select = __webpack_require__(73002);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewListHeader/SortSelect/SortSelect.styles.js

var _templateObject;


var SortSelect_styles_Select = (0,styled_components_browser_esm["default"])(Select/* default */.Z).attrs(function () {
  return {
    mr: 2
  };
})(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-width: 300px;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewListHeader/SortSelect/constants.js
var DEFAULT_FILTER_LENGTH = 2;
var DEFAULT_SORT_OPTIONS_LENGTH = 2;
var sortTypes = [{
  label: 'Mais relevantes',
  value: 'MORE_RELEVANT'
}, {
  label: 'Mais recentes',
  value: 'MOST_RECENT'
}, {
  label: 'Avaliações positivas',
  value: 'MORE_POSITIVE'
}, {
  label: 'Avaliações negativas',
  value: 'MORE_NEGATIVE'
}];
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewListHeader/SortSelect/SortSelect.js







var SortSelect = function SortSelect(_ref) {
  var _structure$route;
  var staticProps = _ref["static"],
    structure = _ref.structure;
  var selectLabel = staticProps.selectLabel;
  var selectedOption = (_structure$route = structure.route) == null ? void 0 : _structure$route.sortType;
  var _ref2 = (structure == null ? void 0 : structure.route) || {},
    filters = _ref2.filters;
  var _useState = (0,react.useState)(filters),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    currentFilters = _useState2[0],
    setCurrentFilters = _useState2[1];
  var _useState3 = (0,react.useState)(sortTypes),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    sortOptions = _useState4[0],
    setSortOptions = _useState4[1];
  var handleChange = (0,react.useCallback)(function (sortOption) {
    var sort = sortTypes.some(function (sortType) {
      return sortType.value === sortOption;
    });
    if (sort) {
      var path = (0,esm/* getCurrentPath */.Jz)({
        page: 1,
        sortType: sortOption
      });
      (0,esm/* routePush */.dY)({
        path: path,
        spa: true
      });
    }
  }, []);
  var getSortedOptions = function getSortedOptions() {
    return sortOptions.map(function (sortOption) {
      if (sortOption.value === selectedOption) {
        return (0,esm_extends/* default */.Z)({}, sortOption, {
          selected: true
        });
      }
      return sortOption;
    });
  };
  var hasFiltersChanged = function hasFiltersChanged() {
    var newFilters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var filtersChanged = JSON.stringify(currentFilters) !== JSON.stringify(newFilters);
    var shouldUpdateSortOptions = newFilters.length > DEFAULT_FILTER_LENGTH && sortTypes.length > DEFAULT_SORT_OPTIONS_LENGTH;
    return filtersChanged && shouldUpdateSortOptions;
  };
  (0,react.useEffect)(function () {
    setCurrentFilters(filters);
    if (hasFiltersChanged(filters)) {
      setSortOptions(sortTypes.slice(0, -2));
    } else if (sortOptions.length === DEFAULT_SORT_OPTIONS_LENGTH && filters.length === DEFAULT_FILTER_LENGTH) {
      setSortOptions(sortTypes);
    }
  }, [filters]);
  return react.createElement(SortSelect_styles_Select, {
    id: "sort-review",
    desktopMode: true,
    textLabel: selectLabel,
    options: getSortedOptions(),
    onChange: handleChange
  });
};
 false ? 0 : void 0;
SortSelect.defaultProps = {
  "static": {
    selectLabel: 'Ordenar'
  },
  structure: {
    route: {
      filters: []
    }
  }
};
SortSelect.ssr = true;
/* harmony default export */ var SortSelect_SortSelect = (SortSelect);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewListHeader/SortSelect/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewListHeader/ReviewListHeader.styles.js

var ReviewListHeader_styles_templateObject;



var TotalLabel = (0,styled_components_browser_esm["default"])(Flex/* default */.Z)(ReviewListHeader_styles_templateObject || (ReviewListHeader_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: ", ";\n  margin-top: 16px;\n"])), (0,build_esm.themeGet)('colors.darkSilver'));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewListHeader/ReviewListHeader.js


var _excluded = ["sortLabel"];






var ReviewListHeader = function ReviewListHeader(_ref) {
  var _data$productRating, _data$productRating$g;
  var staticProps = _ref["static"],
    data = _ref.data,
    structure = _ref.structure;
  var sortLabel = staticProps.sortLabel,
    props = (0,objectWithoutProperties/* default */.Z)(staticProps, _excluded);
  var total = (data == null ? void 0 : (_data$productRating = data.productRating) == null ? void 0 : (_data$productRating$g = _data$productRating.general) == null ? void 0 : _data$productRating$g.commentCount) || 0;
  var sortProps = {
    selectLabel: sortLabel
  };
  return react.createElement(Flex/* default */.Z, (0,esm_extends/* default */.Z)({
    justifyContent: "space-between",
    alignItems: "center",
    "data-testid": "review-list-header"
  }, props), total > 0 && react.createElement(TotalLabel, {
    "data-testid": "review-total",
    fontSize: 3
  }, total, "\xA0", total === 1 ? 'comentário' : 'comentários'), react.createElement(SortSelect_SortSelect, {
    "static": sortProps,
    structure: structure
  }));
};
 false ? 0 : void 0;
ReviewListHeader.defaultProps = {
  data: {},
  "static": {
    sortLabel: 'Ordenar'
  },
  structure: {
    route: {}
  }
};
ReviewListHeader.ssr = true;
/* harmony default export */ var ReviewListHeader_ReviewListHeader = ((0,withLayoutProps/* default */.Z)(ReviewListHeader));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewListHeader/index.js


/***/ }),

/***/ 12232:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ReviewListing_ReviewListing; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/OpinionSnippetBlock/index.js + 3 modules
var OpinionSnippetBlock = __webpack_require__(56337);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(85942);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../modules/build/esm/hooks/useDidUpdateEffect.js
var useDidUpdateEffect = __webpack_require__(13450);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewListing/constants.js
var DEFAULT_CHAR_LIMIT = 300;
var DEFAULT_CHAR_OFFSET = 50;
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewListing/useReviewListing.js





var useReviewListing = function useReviewListing() {
  var _data$productRating, _data$productRating$u, _data$product;
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$data = _ref.data,
    data = _ref$data === void 0 ? {} : _ref$data,
    _ref$structure = _ref.structure,
    structure = _ref$structure === void 0 ? {} : _ref$structure;
  var _ref2 = (structure == null ? void 0 : structure.route) || {},
    filters = _ref2.filters,
    _ref2$page = _ref2.page,
    page = _ref2$page === void 0 ? 1 : _ref2$page,
    _ref2$sortType = _ref2.sortType,
    sortType = _ref2$sortType === void 0 ? 'MORE_RELEVANT' : _ref2$sortType;
  var items = (data == null ? void 0 : (_data$productRating = data.productRating) == null ? void 0 : (_data$productRating$u = _data$productRating.userReviews) == null ? void 0 : _data$productRating$u.items) || [];
  var _useState = (0,react.useState)(items),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    reviews = _useState2[0],
    setReviews = _useState2[1];
  var _useState3 = (0,react.useState)(sortType),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    sortTypeChange = _useState4[0],
    setSortTypeChannge = _useState4[1];
  var _useState5 = (0,react.useState)(filters),
    _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
    filtersChange = _useState6[0],
    setFiltersChange = _useState6[1];
  var getTruncateSize = function getTruncateSize(str) {
    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_CHAR_LIMIT;
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_CHAR_OFFSET;
    var strSize = str == null ? void 0 : str.length;
    return strSize > limit + offset ? limit : strSize;
  };
  var changedSortType = function changedSortType(curent, newSortType) {
    return curent !== newSortType;
  };
  var changedFilters = function changedFilters(curent, newfilters) {
    return JSON.stringify(curent) !== JSON.stringify(newfilters);
  };
  var validateFilters = function validateFilters() {
    setSortTypeChannge(sortType);
    setFiltersChange(filters);
    if (changedSortType(sortTypeChange, sortType) || changedFilters(filtersChange, filters)) {
      setReviews([]);
    }
  };
  (0,useDidUpdateEffect/* default */.Z)(function () {
    validateFilters();
    setReviews((0,toConsumableArray/* default */.Z)(items));
  }, [data == null ? void 0 : (_data$product = data.product) == null ? void 0 : _data$product.id, sortType]);
  (0,useDidUpdateEffect/* default */.Z)(function () {
    validateFilters();
    setReviews(function (acc) {
      return [].concat((0,toConsumableArray/* default */.Z)(acc), (0,toConsumableArray/* default */.Z)(items));
    });
  }, [page, filters]);
  return {
    getTruncateSize: getTruncateSize,
    reviews: reviews
  };
};
/* harmony default export */ var ReviewListing_useReviewListing = (useReviewListing);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewListing/ReviewListing.js






var ReviewListing = function ReviewListing(_ref) {
  var staticProps = _ref["static"],
    data = _ref.data,
    structure = _ref.structure;
  var charLimit = staticProps.charLimit;
  var _useReviewListing = ReviewListing_useReviewListing({
      data: data,
      structure: structure
    }),
    reviews = _useReviewListing.reviews,
    getTruncateSize = _useReviewListing.getTruncateSize;
  return react.createElement(Flex/* default */.Z, {
    gap: 4,
    flexDirection: "column"
  }, reviews == null ? void 0 : reviews.map(function (item) {
    return react.createElement(OpinionSnippetBlock/* default */.Z, {
      key: "review-".concat(item.reviewId),
      review: item,
      charLimit: getTruncateSize(item == null ? void 0 : item.description, charLimit)
    });
  }));
};
ReviewListing.ssr = true;
 false ? 0 : void 0;
ReviewListing.defaultProps = {
  data: {},
  "static": {
    charLimit: 300
  },
  structure: {}
};
/* harmony default export */ var ReviewListing_ReviewListing = ((0,withLayoutProps/* default */.Z)(ReviewListing));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewListing/index.js


/***/ }),

/***/ 34561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ReviewModal_ReviewModal; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var utils_build_esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewModal/ReviewModal.styles.js

var _templateObject, _templateObject2;


var ButtonContainer = (0,styled_components_browser_esm["default"])(atoms/* Box */.xu)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: row;\n  margin-bottom: 36px;\n  margin-top: 60px;\n\n  @media only screen and (max-width: 768px) {\n    margin-bottom: 16px;\n    margin-top: 32px;\n  }\n"])));
var DialogContainer = (0,styled_components_browser_esm["default"])(atoms/* Dialog */.Vq)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 384px !important;\n  max-height: 400px;\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  border-radius: 6px;\n  padding: 22px;\n  margin: 0;\n\n  @media only screen and (max-width: 768px) {\n    width: 312px !important;\n    height: 324px;\n    padding: 16px;\n  }\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewModal/ReviewModal.js








var ReviewModal = function ReviewModal(_ref) {
  var _variant$createUserRe, _variant$createUserRe2, _variant$createUserRe3, _variant$createUserRe4, _variant$createUserRe5;
  var modalOpen = _ref.open,
    variant = _ref.variant,
    data = _ref.data,
    structure = _ref.structure,
    staticProps = _ref["static"];
  var channel = staticProps.channel;
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish,
    subscribe = _usePublisher.subscribe,
    unsubscribe = _usePublisher.unsubscribe;
  var _useState = (0,react.useState)(modalOpen),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var product = data.product;
  var basePath = structure.basePath;
  var handleClickEvent = (0,react.useCallback)(function () {
    setOpen(!open);
  }, [open]);
  (0,react.useEffect)(function () {
    subscribe('review:modal:open', handleClickEvent);
    return function () {
      unsubscribe('review:modal:open', handleClickEvent);
    };
  }, []);
  var handleClickConditional = function handleClickConditional() {
    publish('product:reviewform:modal', {
      structure: structure
    });
    if (channel === 'miniapp') {
      return (0,utils_build_esm/* useCloseMiniApp */.aX)();
    }
    return (0,utils_build_esm/* routePush */.dY)({
      path: "".concat(basePath, "/").concat(product.url),
      spa: true
    });
  };
  var variants = {
    ERROR: {
      buttonLabel: 'Retornar à avaliação',
      description: (variant == null ? void 0 : (_variant$createUserRe = variant.createUserReviewSubmission) == null ? void 0 : _variant$createUserRe.description) || 'Não conseguimos enviar a sua avaliação. Por favor, faça novamente.',
      handleClick: handleClickEvent,
      icon: 'CloseCircle',
      iconColor: 'alert.danger.text',
      textColor: 'text.dark',
      title: variant == null ? void 0 : (_variant$createUserRe2 = variant.createUserReviewSubmission) == null ? void 0 : _variant$createUserRe2.msg
    },
    SUCCESS: {
      buttonLabel: 'Voltar para o produto',
      description: (variant == null ? void 0 : (_variant$createUserRe3 = variant.createUserReviewSubmission) == null ? void 0 : _variant$createUserRe3.description) || 'Após a análise, sua avaliação será publicada.',
      handleClick: handleClickConditional,
      icon: 'DoneCircle',
      iconColor: 'alert.success.text',
      textColor: 'text.attributeLabel',
      title: "".concat(variant == null ? void 0 : (_variant$createUserRe4 = variant.createUserReviewSubmission) == null ? void 0 : _variant$createUserRe4.msg)
    }
  };
  var currentVariant = variants[(variant == null ? void 0 : (_variant$createUserRe5 = variant.createUserReviewSubmission) == null ? void 0 : _variant$createUserRe5.status) || 'SUCCESS'];
  return react.createElement(react.Fragment, null, open && react.createElement(DialogContainer, {
    type: "alert",
    onClickOutside: handleClickEvent,
    position: "center",
    showClose: true,
    visible: open
  }, react.createElement(esm/* Icon */.JO$, {
    name: currentVariant.icon,
    color: currentVariant.iconColor,
    "aria-label": currentVariant.icon,
    m: "0 auto",
    minWidth: 48,
    minHeight: 48,
    display: "block"
  }), react.createElement(atoms/* Text */.xv, {
    color: currentVariant.textColor,
    fontSize: [2, 3],
    fontWeight: "bold",
    textAlign: "center",
    lineHeight: "display",
    mt: ['32px', '40px']
  }, currentVariant.title), react.createElement(atoms/* Text */.xv, {
    mt: ['8px', '24px'],
    color: "text.attributeLabel",
    fontSize: [2, 3],
    fontWeight: "regular",
    textAlign: "center",
    lineHeight: "display"
  }, currentVariant.description), react.createElement(ButtonContainer, null, react.createElement(atoms/* Button */.zx, {
    uppercase: false,
    size: "large",
    width: ['264px', '304px'],
    "data-testid": "button-review-modal",
    onClick: currentVariant.handleClick,
    type: "button"
  }, currentVariant.buttonLabel))));
};
 false ? 0 : void 0;
ReviewModal.defaultProps = {
  data: {},
  open: false,
  "static": {},
  structure: {},
  variant: 'success'
};
ReviewModal.ssr = false;
/* harmony default export */ var ReviewModal_ReviewModal = (ReviewModal);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewModal/index.js


/***/ }),

/***/ 48067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ReviewPaginationButton_ReviewPaginationButton; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js + 2 modules
var Button = __webpack_require__(60861);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewPaginationButton/useReviewPagination.js



var getPagePath = function getPagePath(page) {
  return (0,esm/* getCurrentPath */.Jz)({
    page: page
  });
};
var useReviewPagination = function useReviewPagination(data, structure) {
  var _useState = (0,react.useState)(),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    nextPagePath = _useState2[0],
    setNextPagePath = _useState2[1];
  var _useState3 = (0,react.useState)(true),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    paginateButton = _useState4[0],
    setPaginateButton = _useState4[1];
  var _structure$route = structure == null ? void 0 : structure.route,
    _structure$route$page = _structure$route.page,
    page = _structure$route$page === void 0 ? 1 : _structure$route$page;
  react.useEffect(function () {
    var _data$productRating, _data$productRating$u, _data$productRating$u2;
    var currentPage = Number(page);
    var nextPage = currentPage + 1;
    var totalPages = data == null ? void 0 : (_data$productRating = data.productRating) == null ? void 0 : (_data$productRating$u = _data$productRating.userReviews) == null ? void 0 : (_data$productRating$u2 = _data$productRating$u.page) == null ? void 0 : _data$productRating$u2.totalPages;
    if (currentPage >= totalPages) return setPaginateButton(false);
    setPaginateButton(true);
    return setNextPagePath(getPagePath(nextPage));
  }, [JSON.stringify(data)]);
  return {
    nextPagePath: nextPagePath,
    paginateButton: paginateButton
  };
};
/* harmony default export */ var ReviewPaginationButton_useReviewPagination = (useReviewPagination);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewPaginationButton/ReviewPaginationButton.js







var ReviewPaginationButton = function ReviewPaginationButton(_ref) {
  var staticProps = _ref["static"],
    data = _ref.data,
    structure = _ref.structure;
  var config = structure.config;
  var _ref2 = config || {},
    isMiniApp = _ref2.isMiniApp;
  var label = staticProps.label;
  var _useReviewPagination = ReviewPaginationButton_useReviewPagination(data, structure),
    nextPagePath = _useReviewPagination.nextPagePath,
    paginateButton = _useReviewPagination.paginateButton;
  var handleClickPaginate = function handleClickPaginate(e) {
    e.preventDefault();
    var redirectOptions = {
      options: {
        scroll: false
      },
      path: nextPagePath
    };
    if (isMiniApp) (0,esm/* routeReplace */.fV)(redirectOptions);else (0,esm/* routePush */.dY)((0,esm_extends/* default */.Z)({}, redirectOptions, {
      spa: true
    }));
  };
  return paginateButton && react.createElement(Button/* default */.Z, {
    as: "a",
    href: nextPagePath,
    variation: "outline",
    uppercase: false,
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "20px",
    size: "medium",
    full: true,
    borderRadius: 6,
    "data-testid": "pagination-button",
    onClick: handleClickPaginate
  }, label);
};
ReviewPaginationButton.defaultProps = {
  data: {},
  "static": {
    label: ''
  },
  structure: {}
};
 false ? 0 : void 0;
ReviewPaginationButton.ssr = true;
/* harmony default export */ var ReviewPaginationButton_ReviewPaginationButton = ((0,withLayoutProps/* default */.Z)(ReviewPaginationButton));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewPaginationButton/index.js


/***/ }),

/***/ 73448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ReviewPdpSection_ReviewPdpSection; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Grid/index.js + 2 modules
var Grid = __webpack_require__(8341);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Heading/index.js + 1 modules
var Heading = __webpack_require__(25610);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/RatingLineGroup/index.js
var RatingLineGroup = __webpack_require__(71956);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/ReviewListing/index.js + 3 modules
var ReviewListing = __webpack_require__(12232);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/ReviewTotalizers/index.js + 1 modules
var ReviewTotalizers = __webpack_require__(77137);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/GenericButton/index.js
var GenericButton = __webpack_require__(52516);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var stereo_ui_styles_build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewPdpSection/ReviewPdpSection.styles.js

var _templateObject, _templateObject2, _templateObject3, _templateObject4;




var Content = (0,styled_components_browser_esm["default"])(Flex/* default */.Z)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-top: 34px;\n"])));
var Divider = (0,styled_components_browser_esm["default"])(Box/* default */.Z).attrs(function () {
  return {
    forwardedAs: 'span'
  };
})(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: block;\n  margin-top: ", "px;\n  width: 100%;\n  border-top: 1px solid rgba(185, 185, 185, 0.73);\n"])), (0,stereo_ui_styles_build_esm.themeGet)('space.3'));
var MainContentReview = (0,styled_components_browser_esm["default"])(Box/* default */.Z)(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: '94px 16px 69px';\n"])));
var TotalLabel = (0,styled_components_browser_esm["default"])(Flex/* default */.Z)(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: #51585c;\n  margin-top: 29px;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewPdpSection/ReviewPdpSection.js













var ReviewPdpSection = function ReviewPdpSection(_ref) {
  var _data$productRating, _data$productRating$g;
  var data = _ref.data,
    children = _ref.children,
    staticProps = _ref["static"];
  var total = (data == null ? void 0 : (_data$productRating = data.productRating) == null ? void 0 : (_data$productRating$g = _data$productRating.general) == null ? void 0 : _data$productRating$g.commentCount) || 0;
  var elemRef = (0,react.useRef)(null);
  var title = staticProps.title,
    marginBottomScroll = staticProps.marginBottomScroll;
  var ratingLineGroupProps = staticProps.ratingLineGroupProps,
    genericButtonProps = staticProps.genericButtonProps;
  var handleClickEvent = function handleClickEvent() {
    return (0,esm/* scrollToRef */.BC)(elemRef, marginBottomScroll);
  };
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    subscribe = _usePublisher.subscribe,
    unsubscribe = _usePublisher.unsubscribe;
  (0,react.useEffect)(function () {
    subscribe('product:review:click', handleClickEvent);
    return function () {
      unsubscribe('product:review:click', handleClickEvent);
    };
  });
  return total > 0 && react.createElement(MainContentReview, {
    ref: elemRef,
    yOffset: marginBottomScroll
  }, react.createElement(Heading/* default */.Z, {
    as: "h2"
  }, title), react.createElement(Grid/* default */.Z, {
    mt: 4,
    gridGap: "0 8rem",
    gridTemplateColumns: "2fr 4fr"
  }, react.createElement(atoms/* Flex */.kC, {
    flexDirection: "column"
  }, react.createElement(atoms/* Flex */.kC, null, react.createElement(ReviewTotalizers/* default */.Z, {
    data: data
  })), react.createElement(Divider, {
    backgroundColor: "primary.dark"
  }), react.createElement(Content, {
    flexDirection: "column"
  }, react.createElement(atoms/* Text */.xv, {
    color: "inherit",
    fontWeight: "bold",
    fontSize: 3,
    marginBottom: 4
  }, "Classifica\xE7\xE3o"), react.createElement(RatingLineGroup/* default */.Z, (0,esm_extends/* default */.Z)({}, ratingLineGroupProps, {
    data: data
  })))), react.createElement(atoms/* Flex */.kC, {
    flexDirection: "column"
  }, react.createElement(TotalLabel, {
    "data-testid": "review-total",
    fontSize: 3
  }, total, "\xA0", total === 1 ? 'comentário' : 'comentários'), react.createElement(Divider, {
    backgroundColor: "primary.dark"
  }), children, react.createElement(Content, null, react.createElement(ReviewListing/* default */.Z, {
    data: data
  })), react.createElement(GenericButton/* default */.Z, genericButtonProps))));
};
ReviewPdpSection.ssr = true;
ReviewPdpSection.displayName = 'ReviewPdpSection';
ReviewPdpSection.dataSource = {
  product: {
    query: 'ProductQuery'
  },
  productRating: {
    query: 'ProductRatingQuery'
  }
};
ReviewPdpSection.defaultProps = {
  data: {},
  "static": {}
};
 false ? 0 : void 0;
/* harmony default export */ var ReviewPdpSection_ReviewPdpSection = (ReviewPdpSection);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewPdpSection/index.js


/***/ }),

/***/ 98396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ReviewResult_ReviewResult; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(85942);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Heading/index.js + 1 modules
var Heading = __webpack_require__(25610);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js + 2 modules
var Button = __webpack_require__(60861);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/ReviewResult/index.js + 2 modules
var templates_ReviewResult = __webpack_require__(4294);
// EXTERNAL MODULE: ../graphql/build/esm/index.js
var esm = __webpack_require__(76613);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var utils_build_esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/VisibilitySection/index.js + 1 modules
var VisibilitySection = __webpack_require__(17322);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewResult/ReviewResult.js












var ReviewResult = function ReviewResult(_ref) {
  var _sorts$, _sorts$2;
  var staticProps = _ref["static"],
    structure = _ref.structure,
    data = _ref.data;
  var elemRef = (0,react.useRef)(null);
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    subscribe = _usePublisher.subscribe,
    unsubscribe = _usePublisher.unsubscribe;
  var reviewPageSize = staticProps.reviewPageSize,
    title = staticProps.title,
    link = staticProps.link,
    linkTitle = staticProps.linkTitle,
    showDesktop = staticProps.showDesktop,
    marginBottomScroll = staticProps.marginBottomScroll;
  var _ref2 = data || {},
    review = _ref2.review,
    product = _ref2.product;
  var _ref3 = review || {},
    _ref3$pagination = _ref3.pagination,
    pagination = _ref3$pagination === void 0 ? {} : _ref3$pagination,
    _ref3$reviews = _ref3.reviews,
    reviews = _ref3$reviews === void 0 ? [] : _ref3$reviews,
    _ref3$sorts = _ref3.sorts,
    sorts = _ref3$sorts === void 0 ? [] : _ref3$sorts;
  var initialVars = {
    page: 1,
    sortOrientation: sorts == null ? void 0 : (_sorts$ = sorts[0]) == null ? void 0 : _sorts$.orientation,
    sortType: sorts == null ? void 0 : (_sorts$2 = sorts[0]) == null ? void 0 : _sorts$2.type
  };
  var _useState = (0,react.useState)(reviews),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    list = _useState2[0],
    setList = _useState2[1];
  var _useState3 = (0,react.useState)(initialVars),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    vars = _useState4[0],
    setVars = _useState4[1];
  var _useReview = (0,esm.useReview)(),
    reviewData = _useReview.review,
    getReviewData = _useReview.getData;
  var updateData = function updateData() {
    var page = vars.page,
      sortOrientation = vars.sortOrientation,
      sortType = vars.sortType;
    var productId = (product == null ? void 0 : product.variationId) || (product == null ? void 0 : product.id);
    var filters = {
      productId: productId,
      reviewPage: page,
      reviewPageSize: reviewPageSize,
      reviewSortOrientation: sortOrientation,
      reviewSortType: sortType
    };
    getReviewData(filters);
  };
  (0,react.useEffect)(function () {
    setList(reviews);
    setVars(initialVars);
  }, [structure.asPath]);
  (0,react.useEffect)(function () {
    updateData();
  }, [product, vars]);
  (0,react.useEffect)(function () {
    var _reviewData$review;
    var page = vars.page;
    var response = (reviewData == null ? void 0 : (_reviewData$review = reviewData.review) == null ? void 0 : _reviewData$review.reviews) || [];
    if (response.length === 0) return;
    var moreReviews = page > 1 ? [].concat((0,toConsumableArray/* default */.Z)(list), (0,toConsumableArray/* default */.Z)(response)) : response;
    setList(moreReviews);
  }, [reviewData]);
  var handleChangeSort = function handleChangeSort(_ref4) {
    var type = _ref4.type,
      orientation = _ref4.orientation;
    setVars({
      page: 1,
      sortOrientation: orientation,
      sortType: type
    });
  };
  var handleViewMoreClick = function handleViewMoreClick() {
    var next = vars.page + 1;
    setVars((0,esm_extends/* default */.Z)({}, vars, {
      page: next
    }));
  };
  var handleTitleClickEvent = function handleTitleClickEvent() {
    return (0,utils_build_esm/* scrollToRef */.BC)(elemRef, marginBottomScroll);
  };
  (0,react.useEffect)(function () {
    subscribe('product:review:click', handleTitleClickEvent);
    return function () {
      unsubscribe('product:review:click', handleTitleClickEvent);
    };
  });
  return react.createElement(VisibilitySection/* default */.Z, {
    eventKey: "product:active:section",
    eventValue: "product:review"
  }, react.createElement(react.Fragment, null, title && react.createElement(Heading/* default */.Z, {
    as: "h2",
    color: "base",
    fontSize: 5,
    fontWeight: "medium",
    my: [2, 2, 3, 3],
    ref: elemRef,
    yOffset: marginBottomScroll
  }, title), link && linkTitle && react.createElement(Button/* default */.Z, {
    as: "a",
    href: link,
    m: "10px 0 0 auto",
    maxWidth: "315px"
  }, linkTitle), react.createElement(templates_ReviewResult/* default */.Z, {
    productData: product,
    reviewsData: (0,esm_extends/* default */.Z)({}, review, {
      pagination: (0,esm_extends/* default */.Z)({}, pagination, {
        page: vars.page
      }),
      reviews: list
    }),
    onViewMoreClick: handleViewMoreClick,
    onChangeSort: handleChangeSort,
    showDesktop: showDesktop
  })));
};
ReviewResult.defaultProps = {
  data: {},
  "static": {
    link: '',
    linkTitle: '',
    reviewPageSize: 20,
    showDesktop: false,
    title: ''
  },
  structure: (0,prop_types.shape)({})
};
 false ? 0 : void 0;
ReviewResult.dataSource = {
  product: {
    query: 'ProductQuery'
  },
  review: {
    query: 'ReviewQuery'
  }
};
ReviewResult.ssr = true;
/* harmony default export */ var ReviewResult_ReviewResult = (ReviewResult);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewResult/index.js


/***/ }),

/***/ 24677:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ReviewSelectedFilter_ReviewSelectedFilter; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var build_esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewSelectedFilter/ReviewSelectedFilter.styles.js

var _templateObject;

var TextChip = styled_components_browser_esm["default"].span(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-weight: 500 !important;\n  color: #000;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewSelectedFilter/ReviewSelectedFilter.js







var ReviewSelectedFilter = function ReviewSelectedFilter(_ref) {
  var structure = _ref.structure;
  var _ref2 = (structure == null ? void 0 : structure.route) || {},
    _ref2$filters = _ref2.filters,
    filters = _ref2$filters === void 0 ? [] : _ref2$filters;
  var query = structure.query;
  var rating = filters.find(function (item) {
    return item.type === 'rating';
  });
  function getRatingLabel() {
    var ratingLabels = {
      FIVE_STARS: '5',
      FOUR_STARS: '4',
      ONE_STAR: '1',
      THREE_STARS: '3',
      TWO_STARS: '2'
    };
    if (rating) {
      return ratingLabels[rating.value];
    }
    return null;
  }
  var ratingLabel = getRatingLabel();
  var handleClearFilterRating = function handleClearFilterRating(e) {
    e.preventDefault();
    var filterRating = filters.filter(function (item) {
      return item.type === 'rating';
    }).map(function (item) {
      return {
        type: item.type,
        value: item.value
      };
    });
    var path = (0,build_esm/* urlCleanSelectedFilters */.Ld)(filterRating, query, structure);
    (0,build_esm/* routePush */.dY)({
      path: path,
      spa: true
    });
  };
  var renderTextChip = function renderTextChip() {
    return react.createElement(TextChip, null, ratingLabel, react.createElement(atoms/* Box */.xu, {
      p: "0 4px"
    }, react.createElement(esm/* Star */.Uxw, {
      "data-testid": "star-icon",
      color: "text.scratched",
      height: 16,
      width: 16
    })));
  };
  if (rating) {
    return react.createElement(atoms/* Box */.xu, {
      bg: "background.white",
      "data-testid": "filter-selected-container"
    }, react.createElement(atoms/* Text */.xv, {
      pb: 3,
      fontWeight: "medium",
      fontSize: 2
    }, "Filtros Selecionados"), react.createElement(atoms/* Chip */.Af, {
      clickable: true,
      width: "72px",
      autoSize: true,
      bg: "secondary",
      as: "div",
      color: "base",
      padding: "8px",
      fontSize: "14px",
      lineHeight: "16px",
      endIcon: react.createElement(esm/* Icon */.JO$, {
        name: "Close",
        width: "16px",
        height: "16px",
        color: "#697277",
        "data-testid": "clear-filter",
        onClick: handleClearFilterRating
      }),
      key: ratingLabel,
      id: "chip-selected-filter"
    }, renderTextChip()));
  }
  return null;
};
 false ? 0 : void 0;
ReviewSelectedFilter.defaultProps = {
  structure: {
    route: {}
  }
};
ReviewSelectedFilter.ssr = true;
/* harmony default export */ var ReviewSelectedFilter_ReviewSelectedFilter = ((0,withLayoutProps/* default */.Z)(ReviewSelectedFilter));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewSelectedFilter/index.js


/***/ }),

/***/ 26442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ReviewSummary_ReviewSummary; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Heading/index.js + 1 modules
var Heading = __webpack_require__(25610);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Link/index.js + 2 modules
var Link = __webpack_require__(10200);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/ProductBundleSelector/index.js + 1 modules
var ProductBundleSelector = __webpack_require__(87757);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/VisibilitySection/index.js + 1 modules
var VisibilitySection = __webpack_require__(17322);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/RichDescription/index.js + 2 modules
var RichDescription = __webpack_require__(15439);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewSummary/ReviewSummary.styles.js


var _templateObject, _templateObject2, _templateObject3, _templateObject4;





var Content = (0,styled_components_browser_esm["default"])(Box/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    px: 3
  }, props);
})(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)([""])));
var Description = (0,styled_components_browser_esm["default"])(Box/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    color: 'text.base',
    fontWeight: 'regular',
    lineHeight: 'big',
    textAlign: 'justify'
  }, props);
})(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var StyledChip = (0,styled_components_browser_esm["default"])(atoms/* Chip */.Af)(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-color: #edf8ff;\n  color: ", ";\n  font-size: ", "px;\n  font-weight: ", ";\n  padding: 4px 8px;\n  margin-right: 8px;\n  border-radius: ", ";\n"])), function (props) {
  return (0,build_esm.getTextColor)('primary')(props);
}, (0,build_esm.themeGet)('fontSizes.1'), (0,build_esm.themeGet)('fontWeights.medium'), (0,build_esm.themeGet)('radii.default'));
var StyledStarGroup = (0,styled_components_browser_esm["default"])(esm/* StarGroup */.rlX)(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-right: 8px;\n  color: ", ";\n"])), function (props) {
  return (0,build_esm.getTextColor)('primary')(props);
});
var WarningGenAI = {
  alignItems: 'center',
  color: '#697277',
  display: 'flex',
  fontSize: '14px',
  fontWeight: '400',
  lineHeight: '18px',
  marginBottom: '32px',
  marginTop: '10px'
};
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewSummary/ReviewSummary.js











function ReviewSummary(_ref) {
  var data = _ref.data,
    staticProps = _ref.staticProps,
    structure = _ref.structure;
  var product = data.product,
    reviewSummary = data.reviewSummary;
  var _structure$route = structure.route,
    productId = _structure$route.productId,
    slug = _structure$route.slug,
    categoryId = _structure$route.categoryId,
    subCategoryId = _structure$route.subCategoryId;
  if (!(reviewSummary == null ? void 0 : reviewSummary.summary)) {
    return null;
  }
  var tags = (reviewSummary.tags || []).slice(0, 4);
  return react.createElement(VisibilitySection/* default */.Z, {
    eventKey: "product:active:section",
    eventValue: "product:detail"
  }, react.createElement(Content, {
    "data-testid": "summary-detail"
  }, staticProps.label && react.createElement(Heading/* default */.Z, {
    color: "base",
    fontSize: [2, 2, 5, 5],
    fontWeight: "medium",
    "data-testid": "summary-detail-label",
    as: staticProps.labelAs || 'h2',
    mt: 2,
    mb: 3
  }, staticProps.label), react.createElement(ProductBundleSelector/* default */.Z, {
    data: product
  }), react.createElement(Flex/* default */.Z, {
    justifyContent: "flex-start",
    flexWrap: "wrap",
    mb: "12px"
  }, tags.map(function (tag) {
    return react.createElement(StyledChip, {
      key: tag,
      size: "small",
      as: "div",
      autoSize: true,
      mr: 3
    }, tag);
  })), react.createElement(Description, {
    fontSize: [1, 1, 2, 2],
    "data-testid": "summary-detail-description"
  }, react.createElement(RichDescription/* default */.Z, {
    "static": {
      deniedTags: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'a', 'div', 'img', 'svg'],
      richContent: reviewSummary.summary
    }
  })), react.createElement("div", {
    style: WarningGenAI
  }, react.createElement(StyledStarGroup, null), "Resumo de avalia\xE7\xF5es de clientes feito pela Lu"), react.createElement(Link/* default */.Z, {
    color: "text.primary",
    href: "/review/".concat(productId, "/").concat(slug, "/").concat(categoryId, "/").concat(subCategoryId),
    target: "_blank",
    "data-testid": "review-link",
    mb: "24px"
  }, "Ver todas as avalia\xE7\xF5es", react.createElement(esm/* ChevronRight */._Qn, {
    color: "text.primary"
  }))));
}
ReviewSummary.ssr = true;
ReviewSummary.defaultProps = {
  staticProps: {
    label: 'O que os clientes estão falando do produto',
    labelAs: 'h2'
  }
};
 false ? 0 : void 0;
/* harmony default export */ var ReviewSummary_ReviewSummary = ((0,withLayoutProps/* default */.Z)(ReviewSummary));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewSummary/index.js


/***/ }),

/***/ 61271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ ReviewTermsModal_ReviewTermsModal; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Dialog/index.js + 1 modules
var Dialog = __webpack_require__(66762);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var esm = __webpack_require__(87333);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewTermsModal/ReviewTermsModal.js





var ReviewTermsModal = function ReviewTermsModal(_ref) {
  var modalOpen = _ref.open,
    staticProps = _ref["static"];
  var title = staticProps.title,
    termsUrl = staticProps.termsUrl;
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    subscribe = _usePublisher.subscribe,
    unsubscribe = _usePublisher.unsubscribe;
  var _useState = (0,react.useState)(modalOpen),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var handleClickEvent = (0,react.useCallback)(function () {
    setOpen(!open);
  }, [open]);
  (0,react.useEffect)(function () {
    subscribe('review:terms:open', handleClickEvent);
    return function () {
      unsubscribe('review:terms:open', handleClickEvent);
    };
  }, []);
  return react.createElement(react.Fragment, null, open && react.createElement(Dialog/* default */.Z, {
    onClickOutside: handleClickEvent,
    position: "center",
    showClose: true,
    title: title
  }, react.createElement("iframe", {
    frameBorder: 0,
    height: "400px",
    src: termsUrl,
    title: title,
    width: "100%"
  })));
};
 false ? 0 : void 0;
ReviewTermsModal.defaultProps = {
  open: false,
  "static": {
    termsUrl: 'https://conteudo.magazineluiza.com.br/regulamentos/termos_e_condicoes_review.html',
    title: 'Termos e Condições'
  }
};
ReviewTermsModal.ssr = false;
ReviewTermsModal.displayName = 'ReviewTermsModal';
/* harmony default export */ var ReviewTermsModal_ReviewTermsModal = (ReviewTermsModal);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewTermsModal/index.js


/***/ }),

/***/ 77137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ReviewTotalizers_ReviewTotalizers; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewTotalizers/ReviewTotalizers.js







var ReviewTotalizers = function ReviewTotalizers(_ref) {
  var productRating = _ref.data.productRating,
    showComment = _ref.showComment,
    staticProps = _ref["static"],
    flexDirection = _ref.flexDirection;
  var _ref2 = productRating || {},
    _ref2$general = _ref2.general,
    _ref2$general2 = _ref2$general === void 0 ? {} : _ref2$general,
    _ref2$general2$rating = _ref2$general2.rating,
    rating = _ref2$general2$rating === void 0 ? 0 : _ref2$general2$rating,
    _ref2$general2$review = _ref2$general2.reviewCount,
    reviewCount = _ref2$general2$review === void 0 ? 0 : _ref2$general2$review,
    _ref2$general2$commen = _ref2$general2.commentCount,
    commentCount = _ref2$general2$commen === void 0 ? 0 : _ref2$general2$commen;
  return react.createElement(Flex/* default */.Z, (0,esm_extends/* default */.Z)({
    justifyContent: "space-between",
    width: "100%",
    "data-testid": "review-totalizers",
    gap: 2,
    flexDirection: flexDirection
  }, staticProps), react.createElement(Flex/* default */.Z, {
    gap: 2
  }, react.createElement(Text/* default */.Z, {
    lineHeight: 1,
    fontSize: 44,
    fontWeight: "bold",
    as: "span",
    "data-testid": "review-totalizers-rating"
  }, rating == null ? void 0 : rating.toFixed(1)), react.createElement(esm/* Icon */.JO$, {
    name: "Star",
    color: "stars.base",
    width: 40,
    height: 40
  })), reviewCount > 0 && react.createElement(Text/* default */.Z, {
    lineHeight: "24px",
    fontSize: 3,
    mt: "auto",
    mr: 2,
    "data-testid": "review-totalizers-count"
  }, reviewCount, "\xA0", reviewCount !== 1 ? 'avaliações' : 'avaliação'), commentCount > 0 && showComment && react.createElement(Text/* default */.Z, {
    lineHeight: "24px",
    fontSize: 3,
    mt: "auto",
    "data-testid": "review-comment-count"
  }, commentCount, "\xA0", commentCount !== 1 ? 'comentários' : 'comentário'));
};
 false ? 0 : void 0;
ReviewTotalizers.defaultProps = {
  data: {},
  flexDirection: 'row',
  showComment: false,
  "static": {}
};
/* harmony default export */ var ReviewTotalizers_ReviewTotalizers = ((0,withLayoutProps/* default */.Z)(ReviewTotalizers));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ReviewTotalizers/index.js


/***/ }),

/***/ 15439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ RichDescription_RichDescription; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/RichDescription/RichDescription.styles.js

var _templateObject, _templateObject2, _templateObject3;



var buildSizeImageQuerie = function buildSizeImageQuerie(image, position, size) {
  var sizes = (image == null ? void 0 : image.sizes) || [];
  var value = sizes[position];
  if (!value) return '';
  if (size) {
    return (0,styled_components_browser_esm.css)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n      ", " {\n        height: ", "%;\n        width: ", "%;\n      }\n    "])), (0,build_esm.getMediaQuery)(size), value, value);
  }
  return (0,styled_components_browser_esm.css)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    height: ", "%;\n    width: ", "%;\n  "])), value, value);
};
var Container = (0,styled_components_browser_esm["default"])(Box/* default */.Z)(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  * img {\n    border-radius: ", ";\n    ", "\n    ", "\n    ", "\n    ", "\n  }\n\n  * a {\n    text-decoration: ", ";\n  }\n"])), (0,build_esm.themeGet)('radii.2'), function (_ref) {
  var image = _ref.image;
  return buildSizeImageQuerie(image, 0);
}, function (_ref2) {
  var image = _ref2.image;
  return buildSizeImageQuerie(image, 1, 'small');
}, function (_ref3) {
  var image = _ref3.image;
  return buildSizeImageQuerie(image, 2, 'medium');
}, function (_ref4) {
  var image = _ref4.image;
  return buildSizeImageQuerie(image, 3, 'large');
}, function (_ref5) {
  var linksUnderline = _ref5.linksUnderline;
  return linksUnderline ? 'underline' : 'none';
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/RichDescription/RichDescription.js


var _excluded = ["allowedTags", "deniedTags", "richContent", "settings"];




var RichDescription = function RichDescription(_ref) {
  var _ref$static = _ref["static"],
    _ref$static2 = _ref$static === void 0 ? {} : _ref$static,
    _ref$static2$allowedT = _ref$static2.allowedTags,
    allowedTags = _ref$static2$allowedT === void 0 ? [] : _ref$static2$allowedT,
    _ref$static2$deniedTa = _ref$static2.deniedTags,
    deniedTags = _ref$static2$deniedTa === void 0 ? [] : _ref$static2$deniedTa,
    richContent = _ref$static2.richContent,
    _ref$static2$settings = _ref$static2.settings,
    settings = _ref$static2$settings === void 0 ? {} : _ref$static2$settings,
    props = (0,objectWithoutProperties/* default */.Z)(_ref$static2, _excluded);
  var image = settings.image;
  return Boolean(richContent) && react.createElement(Container, (0,esm_extends/* default */.Z)({
    dangerouslySetInnerHTML: {
      __html: (0,esm/* sanitizeHtml */.Z6)(richContent, {
        allowedTags: allowedTags,
        deniedTags: deniedTags
      })
    },
    image: image,
    "data-testid": "rich-content-container"
  }, props));
};
 false ? 0 : void 0;
RichDescription.defaultProps = {
  "static": {}
};
RichDescription.ssr = true;
/* harmony default export */ var RichDescription_RichDescription = (RichDescription);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/RichDescription/index.js


/***/ })

}]);